import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { getFirstFormNodeByCode } from 'common/entities/formNode/selectors';
import { withFormId } from '../../../FormIdContext';
import { getFormValue } from '../../../../selectors/form';

import FormErrorMessage from '../../../errors/FormErrorMessage';

const formatDateTime = (date, time) => {
    const m = moment(`${date} ${time}`, 'MM/DD/YYYY hh:mmA');
    return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : '';
};

export default function withDates(WrappedComponent) {
    class WithDates extends React.Component {
        static propTypes = {
            startDate: PropTypes.string,
            startTime: PropTypes.string,
            endDate: PropTypes.string,
            endTime: PropTypes.string,
            timeZone: PropTypes.string,
        };

        static defaultProps = {
            startDate: undefined,
            startTime: '00:00:00',
            endDate: undefined,
            endTime: '00:00:00',
            timeZone: undefined,
        };

        render() {
            const { startDate, startTime, endDate, endTime, timeZone, ...restProps } = this.props;

            const startDateTime = startDate ? formatDateTime(startDate, startTime) : undefined;
            const endDateTime = endDate ? formatDateTime(endDate, endTime) : undefined;

            const errors = [
                !startDateTime && 'Invalid start date time.',
                !endDateTime && 'Invalid end date time.',
                !timeZone && 'Invalid time zone.',
            ].filter(Boolean);

            return errors.length ? (
                errors.map((error) => <FormErrorMessage key={error} errorType={`Error: ${error}`} />)
            ) : (
                <WrappedComponent
                    endDateTime={endDateTime}
                    startDateTime={startDateTime}
                    timeZone={timeZone}
                    {...restProps}
                />
            );
        }
    }

    const mapStateToProps = (state, props) => {
        const { formId } = props;

        const startDateNode = getFirstFormNodeByCode(state, formId, props.startDateNodeCode);
        const startTimeNode = getFirstFormNodeByCode(state, formId, props.startTimeNodeCode);
        const endDateNode = getFirstFormNodeByCode(state, formId, props.endDateNodeCode);
        const endTimeNode = getFirstFormNodeByCode(state, formId, props.endTimeNodeCode);
        const timeZoneNode = getFirstFormNodeByCode(state, formId, props.timeZoneNodeCode);

        return {
            startDate: startDateNode ? getFormValue(state, { id: startDateNode.id }) : null,
            startTime: startTimeNode ? getFormValue(state, { id: startTimeNode.id }) : null,
            endDate: endDateNode ? getFormValue(state, { id: endDateNode.id }) : null,
            endTime: endTimeNode ? getFormValue(state, { id: endTimeNode.id }) : null,
            timeZone: timeZoneNode ? getFormValue(state, { id: timeZoneNode.id }) : null,
        };
    };

    return withFormId(connect(mapStateToProps, null)(WithDates));
}
